<template>
    <div class="icon-process-wrapper">
        <div class="icon-process-single wow move-up">
            <div class="icon-process-single__line">
                <div class="dot dot-1"></div>
                <div class="dot dot-2"></div>
                <div class="dot dot-3"></div>
                <div class="dot dot-4"></div>
                <div class="dot dot-5"></div>
                <div class="dot dot-4"></div>
                <div class="dot dot-3"></div>
                <div class="dot dot-2"></div>
                <div class="dot dot-1"></div>
            </div>
            <div class="icon-process-single__content-wrap">
                <div class="icon-process-single__media">
                    <i class="fa fa-fire"></i>
                </div>
                <h5 class="icon-process-single__title">Po dezinfekci potrubí</h5>
                <div class="icon-process-single__text">
                  <p>Je vyhotoven <strong>"Protokol o dezinfekci a proplachu potrubí"</strong>.</p><p> Následně je odebrán vzorek <strong>akreditovaným vzorkařem</strong>, který vyhotoví <strong>"Protokol o odběru vzorku"</strong>.</p><p>Vzorek je potom odvezen do laboratoře akreditované ČIA k provedení kráceného rozboru</p>
                </div>
            </div>
        </div>
        <div class="icon-process-single wow move-up">
            <div class="icon-process-single__line">
                <div class="dot dot-1"></div>
                <div class="dot dot-2"></div>
                <div class="dot dot-3"></div>
                <div class="dot dot-4"></div>
                <div class="dot dot-5"></div>
                <div class="dot dot-4"></div>
                <div class="dot dot-3"></div>
                <div class="dot dot-2"></div>
                <div class="dot dot-1"></div>
            </div>
            <div class="icon-process-single__content-wrap">
                <div class="icon-process-single__media">
                  <i class="fa fa-water"></i>
                </div>
                <h5 class="icon-process-single__title">Uvedení potrubí do provozu</h5>
                <div class="icon-process-single__text">
                  <p>Zprovoznit vnitřní vodovod pro pitnou vodu je možno až po obdržení <strong>Protokolu o mikrobiologické a chemické nezávadnosti vody</strong> dle vyhlášky č.252/2004 z laboratoře akreditované ČIA.</p>
                  <p><strong>Po dezinfekci musí být vodovod zprovozněn do 7 dnů.</strong></p>


                </div>
            </div>
        </div>
        <div class="icon-process-single wow move-up">
            <div class="icon-process-single__line">
                <div class="dot dot-1"></div>
                <div class="dot dot-2"></div>
                <div class="dot dot-3"></div>
                <div class="dot dot-4"></div>
                <div class="dot dot-5"></div>
                <div class="dot dot-4"></div>
                <div class="dot dot-3"></div>
                <div class="dot dot-2"></div>
                <div class="dot dot-1"></div>
            </div>
            <div class="icon-process-single__content-wrap">
                <div class="icon-process-single__media">
                    <i class="fa fa-chart-line"></i>
                </div>
                <h5 class="icon-process-single__title">Protokol, termíny a cena</h5>
                <div class="icon-process-single__text">
                  <p>Kdy je vyžadován <a href="https://con1.artatolstatic.com/file/52cf4ef0-e0c2-4094-8083-f943575befcd.pdf" target="_blank" class="text-info">protokol o dezinfekci a proplachu</a></p>

                  <p>Volné <a href="#terminy" class="text-info">termíny na provedení</a> dezinfekce a proplachu potrubí a <a href="#cena" class="text-info">informace k ceně</a>.</p>

                  <p>Provádím dezinfekci a proplach nových i stávajících <a href="#dezinfekce" class="text-info">vodovodů, rozvodů vody a vodovodních řadů</a>.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'Gradation',
    };
</script>
